/**
 * **版号** —— 印在牌左上角的三字母。
 *
 * 规则：**剔除元音，取定音三辅音**（`Exception → XCP`、`Catch → CTH`、
 * `Suspend → SPD`）。元音打头的词直接去元音会把读音毁掉，所以 `Exception`
 * 是唯一按辅音骨架取的例外。
 *
 * ⚠️ 这是**判断，不是算法** —— 所以它是一张表，不是一个函数。
 * 想加一条规则去生成它，就等于承认这张表才是对的：`NUL` 五张全一样，
 * 任何算法都给不出这个答案。
 *
 * ⚠️ 也正因为五张无效牌的版号**不唯一**，它绝不能当键用 ——
 * 缓存键、比较、连击判定一律走 `card.id`。
 */
export const PLATE_CODES: Readonly<Record<string, string>> = {
  Exception: 'XCP',
  Catch: 'CTH',
  SigTrap: 'SGT',
  Signal: 'SGN',
  Suspend: 'SPD',
  Await: 'AWT',
  Hash: 'HSH',
  Debug: 'DBG',
  // ASCII 的**空字符 0x00** —— 它们本来就"没有值"，所以五张共用一个版号
  Powerless1: 'NUL',
  Powerless2: 'NUL',
  Powerless3: 'NUL',
  Powerless4: 'NUL',
  Powerless5: 'NUL',
};

/** 查不到就返回 `???` —— 一张**看得见的占位符**，不是空白 */
export function plateCode(local: string): string {
  return PLATE_CODES[local] ?? '???';
}
